import React from "react";
import { Component, createElement } from 'react';
import MaskedInput from 'react-text-mask';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';

const mapError = ({ hasHelperText = true, meta: { touched, error, warning } = {}, input, ...props }) => {
    const errorProps =
    touched && (error || warning)
      ? {
          ...props,
          ...input,
          error: Boolean(error || warning)
        }
      : { ...input, ...props }

    if (touched && hasHelperText && (error || warning)) {
        errorProps.helperText = error || warning;
    }

    return errorProps;
};

const isStateLess = Component => !Component.prototype.render

function createComponent(MaterialUIComponent, mapProps) {
    class InputComponent extends Component {
        getRenderedComponent() {
          return this.component
        }
        render() {
          return createElement(MaterialUIComponent, {
            ...mapProps(this.props),
            ref: (!isStateLess(MaterialUIComponent) ? el => this.component = el : null)
          })
        }
    }
    InputComponent.displayName = `ReduxFormMaterialUI${MaterialUIComponent.name}`
    return InputComponent
};

export const MaterialTextField = createComponent(TextField, ({
    defaultValue,
    ...props
}) => ({
    margin: "dense",
    fullWidth: true,
    FormHelperTextProps: { classes: {error: "input-error"} },
    variant: "outlined",
    InputProps: props.endAdornment ? { endAdornment: <InputAdornment position="end">{props.endAdornment}</InputAdornment> } : { classes: {multiline: "padded-textarea"} },
    ...mapError(props)
}));

export const MaterialMaskedTextField = (wrapperProps) => {
    const { input, startAdornment, ...rest } = wrapperProps;
    return (
        <MaskedInput {...input}
                     {...rest}
                     showMask={true}
                     render={(ref, props) => (
                         <MaterialTextField inputRef={ref}
                                            InputLabelProps={{ shrink: !!(input.value || startAdornment || rest.placeholder) }}
                                            InputProps={ startAdornment ? { startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment> } : {}}
                                            {...mapError(wrapperProps)}
                                            {...props} />
                     )}
                     guide={true} />
)};

export const MaterialCheckbox = createComponent(Checkbox, ({
    input: { onChange, value, ...inputProps },
    meta,
    onChange: ignoredOnChange,
    defaultChecked,
    ...props
}) => ({
    ...inputProps,
    ...props,
    checked: value ? true : false,
    onChange: (event, isInputChecked) => {
        onChange(isInputChecked)
    }
}));

export const MaterialRadioGroup = createComponent(RadioGroup, ({
    input: { onChange, value, ...inputProps },
    meta,
    onChange: onChangeFromField,
    ...props
}) => ({
    ...inputProps,
    ...props,
    value,
    onChange: (event, value) => {
      onChange(value)
      if (onChangeFromField) {
          onChangeFromField(value)
      }
    }
}));

export const MaterialSelect = createComponent(Select, ({
    input: { onChange, value, onBlur, ...inputProps },
    onChange: onChangeFromField,
    defaultValue,
    ...props
}) => ({
    ...mapError({ ...props, hasHelperText: false }),
    ...inputProps,
    value: value,
    onChange: event => {
        onChange(event.target.value);
        if (onChangeFromField) {
            onChangeFromField(event.target.value);
        }
    },
    onBlur: () => onBlur(value)
}));

export const MaterialSwitch = createComponent(Switch, ({
    input: { onChange, value, ...inputProps },
    checked,
    meta,
    ...props
}) => ({
    ...inputProps,
    ...props,
    onChange,
    checked: !!value
}));



// WEBPACK FOOTER //
// ./src/components/MaterialInput.js